import { queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY } from '@inpart-io/devtools-vue';
import { type ILeadStatusConfiguration, leadStatusConfigurationProperties } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { SAVE_SEARCH_RESULT } from '@/store/base/search/actions';

export const RETRIEVE_ALL_STATUS_CONFIG = 'retrieveAllStatusConfig';

export const actions: ActionTree<ILeadStatusConfiguration, unknown> = {
    async [RETRIEVE_ALL_STATUS_CONFIG](context): Promise<number[]> {
        const query = queryBuilder.build(undefined, undefined, undefined, [
            {
                attribute: 'name',
                direction: 'ASC'
            }
        ]);
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query,
            properties: leadStatusConfigurationProperties.DEFAULT
        });
        await context.dispatch(SAVE_SEARCH_RESULT, { key: 'all', idList });
        return idList;
    }
};
